<template>
  <rabbey-base-drawer
    ref="drawer"
    direction="rtl"
    size="50%"
    :title="title"
    :wrapperClosable="false"
    :append-to-body="true"
    :before-close="beforeClose"
    v-bind="$attrs"
    :drawer.sync="drawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              ref="form"
              :model="form"
              size="mini"
              label-position="left"
              :rules="rules"
              label-width="150px"
              style="padding-top: 25px"
            >
              <el-form-item
                label="Nombre"
                style="font-weight: bold"
                prop="Name"
              >
                <el-input
                  :disabled="!canEdit"
                  v-model="form.Name"
                  placeholder="Nombre del Objetivo"
                ></el-input>
              </el-form-item>

              <el-row>
                <el-col>
                  <el-form-item label-width="0" prop="Description">
                    <quill-editor
                      :disabled="!canEdit"
                      ref="myQuillEditor"
                      v-model="form.Description"
                    ></quill-editor>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="Creado por">
                <el-input
                  style="width: 30%"
                  v-model="CreateByName"
                  disabled
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if="isCEO"
                label="Tipo Objetivo"
                prop="TypeObjetive"
                style="font-weight: bold; margin-top: 40px"
              >
                <el-select
                  style="width: 30%"
                  v-model="form.TypeObjetive"
                  placeholder="Seleccionar un Tipo"
                  filterable
                >
                  <el-option
                    label="ESTRATEGICOS"
                    value="ESTRATEGICO"
                  ></el-option>
                  <el-option label="GERENCIAL" value="GERENCIAL"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Responsable"
                prop="ResposibleID"
                style="font-weight: bold; margin-top: 40px"
              >
                <el-select
                  v-model="form.ResposibleID"
                  style="width: 30%"
                  :disabled="!canEdit"
                  placeholder="Selecionar un Responsable"
                  clearable
                  filterable
                  v-loading="loading_user"
                >
                  <el-option
                    v-for="d in directors"
                    :key="d.EmployeeID"
                    :label="d.Name"
                    :value="d.EmployeeID"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Fecha Limite"
                prop="DateEnd"
                style="font-weight: bold; width: 65%"
              >
                <el-date-picker
                  type="datetime"
                  placeholder="Fecha Limite"
                  v-model="form.DateEnd"
                  style="width: 50%"
                  :disabled="!canEdit"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label-width="0">
                <el-button @click="clear(true, true)">Cancel</el-button>

                <el-button
                  v-if="isCreated || isOwner || isCEO"
                  type="primary"
                  :disabled="!isEdit"
                  @click="saveForm"
                  :loading="loading_save"
                  >Guardar cambios</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </rabbey-base-drawer>
</template>

<script>
import { formatDate } from "@/utils";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "ObjectiveForm",
  inheritAttrs: false,
  components: {
    quillEditor
  },
  data() {
    return {
      drawer: false,
      title: "Nuevo objectivo",
      loading_save: false,
      loading_user: false,
      isvalid: false,
      isloading: true,
      isEdit: false,
      isCreated: false,
      Editing: false,
      Owner: false,
      directors: [],
      objetive: {},
      form: {
        Description: "",
        Name: "",
        TypeObjetive: "",
        ResposibleID: null,
        DateEnd: null,
        Owner: null
      },
      rules: {
        perpectiva: [
          {
            required: true,
            message: "Debe de selecionar una perspectiva",
            trigger: "change"
          }
        ],
        ResposibleID: [
          {
            required: true,
            message: "Debe de selecionar un Responsable",
            trigger: "change"
          }
        ],
        Name: [
          {
            required: true,
            message: "Nombre de objetivo es requerido",
            trigger: "change"
          }
        ],
        TypeObjetive: [
          {
            required: false,
            message: "Tipo de objetivo es requerido",
            trigger: "change"
          }
        ],
        Description: [
          {
            required: true,
            message: "Debe ingregar la descipcion del objetivo",
            trigger: "change"
          }
        ],
        DateEnd: [
          {
            required: true,
            message: "La fecha de fin es requerida",
            trigger: "change"
          }
        ]
      },
      perpective: null
    };
  },
  mounted() {
    this.loadUsersfromServer();
  },
  computed: {
    isOwner() {
      return this.currentUser.UserID === this.objetive.Owner;
    },
    isCEO() {
      return this.currentUser.Roles.some((rol) => rol.Name == "CEO");
    },
    canEdit() {
      return this.isOwner || this.isCreated || this.isCEO;
    },
    CreateByName: {
      get() {
        if (!this.form.Owner) return "";
        const user = this.$store.getters["user/getUserById"](this.form.Owner);
        return user !== undefined ? user.FullName : "";
      }
    }
  },
  methods: {
    formatDate,
    show(data = {}, isView = true, isEdit = false, isCreated = false) {
      // Si es crear data es la data de la perspectiva.
      this.isView = isView;
      this.isEdit = isEdit;
      if (isCreated) {
        this.clear(false);
        this.isCreated = true;
        this.form.PerpectiveId = data.Id;
        this.title = data.Name;
      } else {
        this.title = data.perspectiveName;
        this.isCreated = false;
        this.objetive = data;
        this.Owner = this.currentUser.UserID === data.Owner;
        this.perpective = data.PerpectiveId;
        this.form = data;
        // Push view objective
        this.$http
          .post("/api/CMI/Objetives/UpdateObjetiveStatus", {
            ResponsableID: this.currentUser.EmployeeID,
            ObjetiveID: data.ID
          })
          .catch((error) => console.error(error));
      }

      this.loadUsersfromServer();
      this.drawer = true;
    },
    clear(resetFields = true, closeDrawer = false) {
      if (resetFields) {
        this.$refs.form.resetFields();
      }
      this.form = {
        directionID: "",
        perpectiva: "",
        TypeObjetive: "",
        perspectiveId: null,
        directorID: "",
        date1: "",
        date2: "",
        name: "",
        desc: ""
      };

      if (closeDrawer) {
        this.drawer = false;
      }
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        this.loading_save = true;
        if (valid) {
          const DateInit = this.formatDate(this.form.date1, "YYYY-MM-DD");
          const DateEnd = this.formatDate(this.form.DateEnd, "YYYY-MM-DD");

          const body = {
            CompanySeleted: this.currentCompany,
            DateInit: DateInit,
            DateEnd: DateEnd,
            ...this.form
          };

          this.$http
            .post("/api/CMI/Objetives/addNewObjetive", body)
            .then(() => {
              // Este evento hace que la data de la tabla se refresque
              this.$emit("submit-success");

              let message = "El objetivo fue actualziado";

              if (this.isCreated) {
                message = "El objetivo fue creado";
              }

              this.$message.success(message);

              // Desplegar la linea del nuevo objetivo
              /* setTimeout(() => {
                this.clickSelectedSettion();
              }, 500); */
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err.message
              });
            })
            .finally(() => {
              this.clear(true);
              this.loading_save = false;
              this.drawer = false;
              this.$emit("update-data");
            });
        } else {
          this.loading_save = false;
          return false;
        }
      });
    },
    loadUsersfromServer() {
      const { EmployeeId } = this.currentUser;

      this.loading_user = true;

      this.$http
        .get(`/api/CMI/Objetives/GetUsersObjetivos`, {
          params: {
            CompanySelected: this.currentCompany,
            employeeid: EmployeeId
          }
        })
        .then((response) => {
          this.directors = response.data;
          /* if (!this.canEdit) {
            this.$emit("canCreate", true);
          } */
          if (response.data.length === 0) {
            // el usuario no es el encargado quien creo la solicitud
            if (this.objetive) {
              this.directors = [
                {
                  DirectorID: this.objetive.ResposibleID,
                  Name: this.objetive.Responsable
                }
              ];
            }
          }
        })
        .catch((er) => {
          console.error(er);
        })
        .finally(() => {
          this.loading_user = false;
        });
    },
    getForm() {
      return this.$refs.form;
    },
    onClickEdit() {
      if (this.isEdit) {
        this.saveObjective();
      }
    },
    getObjetivosForm() {
      // validating selection table
      const doc = document.querySelector(".expanded");
      if (doc !== null) {
        const label = doc
          .getElementsByTagName("td")[1]
          .getElementsByTagName("div")[0].innerHTML;
        this.selectionLabel = label;
      }

      this.$refs.newform.getForm().validate((valid) => {
        if (valid) {
          this.saveObjective();
        } else {
          return false;
        }
      });
    },
    beforeClose(done) {
      this.clear(true);
      done();
    }
  }
};
</script>
